
<img class="right-oval" src="assets/img/ovals/grey-oval-right.png"/>

<ion-content>

  <div class="page-wrapper">

    <span class="back-button" (click)="returnToAccount()">
      <ion-icon name="arrow-back"></ion-icon>
      Back to account
    </span>

    <div class="middle-info">
      
      <div class="section-header">Payment methods</div>

      <div *ngFor="let customer of userService.user.allCustomers" >
        <ion-item class="input-item" lines="none" [ngClass]="editingCard == customer.id ? '' : 'not-editing'">
          <ion-icon class="start-icon" slot="start" name="card"></ion-icon>
          <ion-label class="clickable-label" (click)="editCard(customer)"> {{ paymentCardText(customer) }} </ion-label>
          <div slot="end" class="default-symbol" *ngIf="isDefault(customer) && editingCard !== customer.id">
              <ion-icon slot="start" name="checkmark"></ion-icon>
              Default
          </div>
          <ion-button slot="end" fill="clear" *ngIf="editingCard !== customer.id" (click)="deleteCard(customer)">
              Remove
          </ion-button>
        </ion-item>

        <div *ngIf="editingCard == customer.id" class="editing-section">
          <label class="radio-section">
            <input type="radio" class="radio-button" id="default-radio">
            <span class="radio-button__control"></span>
            <span class="radio-label">Mark as default</span>
          </label>

          <div class="editing-buttons">
            <ion-button color="marine" (click)="saveIsDefault(customer)" class="save-button SC-floating-button SC-floating-button-wide SC-floating-button-less-tall">Save</ion-button>

            <ion-button class="cancel-button" fill="clear" (click)="closeEditCard()">
              Cancel
            </ion-button>
          </div>

        </div>
      </div>

      <div class="submit-button" *ngIf="!addingPayment">
        <ion-button color="marine" (click)="addNewPayment()" class="SC-floating-button SC-floating-button-wide SC-floating-button-less-tall" [disabled]="editingCard">Add new payment method</ion-button>
      </div>

      <div *ngIf="addingPayment" class="adding-payment">

        <div class="section-header">Add a payment method</div>

        <div>
          <ion-item class="booking-input" lines="none">
            <ion-input placeholder="Name on card" [(ngModel)]="cardFields.cardholderName" name="cardholderName" type="text" #cardholderName="ngModel"></ion-input>
          </ion-item>
          <div class="form-row">
            <div id="card-element">
              <!-- a Stripe Element will be inserted here. -->
            </div>
            <div id="card-errors"></div>
          </div>
        </div>

        <div class="submit-button">
          <ion-button color="marine" (click)="saveNewPayment()" class="save-button SC-floating-button SC-floating-button-wide SC-floating-button-less-tall">Save payment method</ion-button>
          
          <ion-button class="cancel-button" fill="clear" (click)="closeNewPayment()">
            Cancel
          </ion-button>
        </div>
      </div>

    </div>

  </div>

</ion-content>